import { Facebook, Instagram, Linkedin } from "lucide-react";
import { useI18n } from "../i18n";
import { CONTACT } from "../lib/contact";

const LEGAL_CREDIT_PT = `A DECISÃO ORDENADA, LDA. Intermediário de Crédito Vinculado, com o registo n.º 0006056, autorizado pelo Banco de Portugal para a prestação de serviços de consultoria e autorizado para a prestação de serviços de intermediação de crédito (Apresentação ou proposta de contratos de crédito a consumidores; Assistência a consumidores, mediante a realização de atos preparatórios ou de outros trabalhos de gestão pré-contratual relativamente a contratos de crédito que não tenham sido por si apresentados ou propostos). Contratos de crédito abrangidos: Crédito à Habitação e Crédito aos Consumidores. Mutuantes ou grupos de mutuantes com quem mantém contrato de vinculação: BANCO BPI S.A., BANCO SANTANDER TOTTA, S.A., CAIXA GERAL DE DEPÓSITOS, S.A., NOVO BANCO, S.A., BANCO CTT, S.A., BANKINTER, SA — SUCURSAL EM PORTUGAL, ABANCA CORPORACIÓN BANCARIA, SA, SUCURSAL EM PORTUGAL, UNION DE CRÉDITOS INMOBILIÁRIOS, S.A. — ESTABLECIMIENTO FINANCIERO DE CRÉDITO (SOCIEDAD UNIPERSONAL) — SUCURSAL EM PORTUGAL, BNI — BANCO DE NEGÓCIOS INTERNACIONAL (EUROPA), S.A., COFIDIS, BNP PARIBAS PERSONAL FINANCE, S.A. — SUCURSAL EM PORTUGAL, SICAM — CAIXA CENTRAL E CAIXAS DE CRÉDITO AGRÍCOLA MÚTUO.`;

const LEGAL_INSURANCE_PT = `A DS SEGUROS é uma marca da empresa Decisões e Soluções — Intermediários de Crédito, Lda, que é mediador inscrito desde 2009. A empresa está inscrita junto da ASF com a categoria de Agente de Seguros, sob o n.º 409311648/3, com autorização para Ramos Vida e Não Vida, verificável em `;

const LEGAL_INSURANCE_PT_SUFFIX = `. O mediador de seguros não assume a cobertura de riscos.`;

const LEGAL_CREDIT_EN = `DECISÃO ORDENADA, LDA., Tied Credit Intermediary, registered under no. 0006056, authorized by the Bank of Portugal to provide consulting services and authorized to provide credit intermediation services (Presentation or proposal of credit contracts to consumers; Assistance to consumers through preparatory acts or other pre-contractual management activities related to credit contracts not presented or proposed by them). Types of credit contracts covered: Mortgage Credit and Consumer Credit. Lenders or groups of lenders with whom it maintains binding agreements: BANCO BPI S.A., BANCO SANTANDER TOTTA, S.A., CAIXA GERAL DE DEPÓSITOS, S.A., NOVO BANCO, S.A., BANCO CTT, S.A., BANKINTER, SA — SUCURSAL EM PORTUGAL, ABANCA CORPORACIÓN BANCARIA, SA, SUCURSAL EM PORTUGAL, UNION DE CRÉDITOS INMOBILIÁRIOS, S.A. — ESTABLECIMIENTO FINANCIERO DE CRÉDITO (SOCIEDAD UNIPERSONAL) — SUCURSAL EM PORTUGAL, BNI — BANCO DE NEGÓCIOS INTERNACIONAL (EUROPA), S.A., COFIDIS, BNP PARIBAS PERSONAL FINANCE, S.A. — SUCURSAL EM PORTUGAL, SICAM — CAIXA CENTRAL E CAIXAS DE CRÉDITO AGRÍCOLA MÚTUO.`;

const LEGAL_INSURANCE_EN = `DS SEGUROS is a brand of Decisões e Soluções — Intermediários de Crédito, Lda, an insurance intermediary registered since 2009. The company is registered with ASF (Portuguese Insurance and Pension Funds Supervisory Authority) as an Insurance Agent under no. 409311648/3, authorized for Life and Non-Life branches, verifiable at `;

const LEGAL_INSURANCE_EN_SUFFIX = `. The insurance intermediary does not assume risk coverage.`;

const Footer = () => {
  const { t, lang } = useI18n();
  const isPt = lang === "pt";
  const verifLabel = isPt ? "Informação verificável em " : "Verifiable at ";
  return (
    <footer
      data-testid="footer"
      className="relative border-t border-white/5 bg-[#040406] pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-12 mb-14">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <img src="/logo-da-gold.png" alt="Diogo Almeida" className="w-12 h-12 object-contain" data-testid="footer-logo" />
              <div>
                <div className="text-2xl font-medium text-white tracking-tight leading-none">
                  Diogo Almeida
                </div>
                <div className="text-xs text-white/50 mt-1">
                  {isPt ? CONTACT.role_pt : CONTACT.role_en}
                </div>
              </div>
            </div>
            <p className="text-white/50 text-sm leading-relaxed max-w-md mb-6">{t.footer.tag}</p>
            <div className="flex items-center gap-3" data-testid="social-links">
              <a
                href={CONTACT.facebook}
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 rounded-full border border-white/10 hover:border-[#A60056] hover:bg-[#A60056]/10 flex items-center justify-center text-white/70 hover:text-white transition-colors"
                aria-label="Facebook"
                data-testid="social-facebook"
              >
                <Facebook className="w-4 h-4" />
              </a>
              <a
                href={CONTACT.instagram}
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 rounded-full border border-white/10 hover:border-[#A60056] hover:bg-[#A60056]/10 flex items-center justify-center text-white/70 hover:text-white transition-colors"
                aria-label="Instagram"
                data-testid="social-instagram"
              >
                <Instagram className="w-4 h-4" />
              </a>
              <a
                href={CONTACT.linkedin}
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 rounded-full border border-white/10 hover:border-[#A60056] hover:bg-[#A60056]/10 flex items-center justify-center text-white/70 hover:text-white transition-colors"
                aria-label="LinkedIn"
                data-testid="social-linkedin"
              >
                <Linkedin className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs uppercase tracking-[0.2em] text-white/40 mb-4">
              {isPt ? "Contacto" : "Contact"}
            </div>
            <ul className="space-y-2 text-white/70 text-sm">
              <li>
                <a href={`tel:${CONTACT.phone}`} className="hover:text-white transition-colors">
                  {CONTACT.phoneDisplay}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${CONTACT.email}`}
                  className="hover:text-white transition-colors break-all"
                >
                  {CONTACT.email}
                </a>
              </li>
              <li>
                <a
                  href={CONTACT.whatsapp()}
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-white transition-colors"
                >
                  WhatsApp
                </a>
              </li>
              <li>
                <a
                  href={CONTACT.calendar}
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-white transition-colors"
                >
                  {isPt ? "Agendar reunião" : "Book meeting"}
                </a>
              </li>
              <li className="pt-2 text-white/50 leading-relaxed" data-testid="footer-address">
                {CONTACT.address}
              </li>
              <li>
                <a
                  href={CONTACT.gmaps}
                  target="_blank"
                  rel="noreferrer"
                  className="text-[#A60056] hover:underline"
                  data-testid="footer-gmaps-link"
                >
                  {isPt ? "Ver no Google Maps" : "View on Google Maps"}
                </a>
              </li>
              <li>
                <a
                  href={CONTACT.reviewUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="text-[#A60056] hover:underline"
                  data-testid="footer-review-link"
                >
                  {isPt ? "Deixe a sua avaliação no Google" : "Leave a Google review"}
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.2em] text-white/40 mb-4">
              {isPt ? "Navegação" : "Navigation"}
            </div>
            <ul className="space-y-2 text-white/70 text-sm">
              <li><a href="#services" className="hover:text-white">{t.nav.services}</a></li>
              <li><a href="#how" className="hover:text-white">{t.nav.how}</a></li>
              <li><a href="#testimonials" className="hover:text-white">{t.nav.testimonials}</a></li>
              <li><a href="#faq" className="hover:text-white">{t.nav.faq}</a></li>
            </ul>
          </div>
        </div>

        <div
          className="border-t border-white/5 pt-8 mb-6 text-[11px] leading-relaxed text-white/35 text-justify space-y-4"
          data-testid="legal-disclaimer"
        >
          <div className="text-[10px] uppercase tracking-[0.25em] text-white/40 mb-3 text-left">
            {isPt ? "Informação legal" : "Legal information"}
          </div>
          <p>
            {isPt ? LEGAL_CREDIT_PT : LEGAL_CREDIT_EN} {verifLabel}
            <a
              href="https://www.bportugal.pt/intermediariocreditofar/decisao-ordenada-lda"
              target="_blank"
              rel="noreferrer"
              className="text-[#A60056] hover:underline break-all"
            >
              bportugal.pt/intermediariocreditofar/decisao-ordenada-lda
            </a>
            .
          </p>
          <p>
            {isPt ? LEGAL_INSURANCE_PT : LEGAL_INSURANCE_EN}
            <a
              href="https://www.asf.com.pt"
              target="_blank"
              rel="noreferrer"
              className="text-[#A60056] hover:underline"
            >
              www.asf.com.pt
            </a>
            {isPt ? LEGAL_INSURANCE_PT_SUFFIX : LEGAL_INSURANCE_EN_SUFFIX}
          </p>
        </div>

        <div className="pt-6 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/40">
            © {new Date().getFullYear()} Diogo Almeida · {t.footer.rights}
          </p>
          <p className="text-xs text-white/30 text-center md:text-right">
            {CONTACT.company} · {CONTACT.address}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
